import { Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const Card1TooltipContent = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div>
        <span className="font-semibold">
          {t('partner.total_current_month_budget')}
        </span>
        : {t('partner.total_current_month_budget_tooltip')}
      </div>
      <Divider sx={{ my: 1, borderColor: '#E5F0FF' }} variant="fullWidth" />
      <div>
        <span className="font-semibold">
          {t('partner.total_previous_month_budget')}
        </span>
        : {t('partner.total_previous_month_budget_tooltip')}
      </div>
    </div>
  );
};

export const Card2TooltipContent = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="font-semibold">{t('partner.current_month_balance')}:</div>
      <div className="flex items-center gap-2 text-sm">
        <div className="font-medium">
          {t('partner.current_month_balance')} ={' '}
        </div>
        <div className="flex flex-col justify-center text-center items-center leading-tight">
          <span className="border-b border-gray-400 px-1">
            ({t('partner.current_month_balance_tooltip1')} *{' '}
            {t('partner.current_month_balance_tooltip2')})
          </span>{' '}
          <span className="px-1">
            {t('partner.current_month_balance_tooltip3')}
          </span>
        </div>
      </div>
      <Divider sx={{ my: 1, borderColor: '#E5F0FF' }} />
      <div>
        <span className="font-semibold">
          {t('partner.previous_month_balance')}
        </span>
        : {t('partner.previous_month_balance_tooltip')}
      </div>
    </div>
  );
};

export const PointsCardTooltipContent = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div>
        <span className="font-semibold">
          {t('label.total_points_collected')}
        </span>
        : {t('label.total_points_collected_tooltip')}
      </div>
    </div>
  );
};

export const SummaryCardTooltipContent = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="font-semibold">{t('partner.total_you_made')}:</div>
      <div>{t('partner.total_you_made_tooltip')}</div>
    </div>
  );
};
